﻿import { Component } from '@angular/core';

@Component({
    selector: 'users',
    templateUrl: './users.component.html'
})
export class UsersComponent {
    api: any = { Search: "userdetail/search", Delete: "userdetail/delete", Edit: "/user-save", Upload: "userdetail/upload", UploadTemplate: "/templates/upload/users.xlsx" };
    columns: any;
    header: string = "Users";
    isLoad: boolean = false;
    type: string = "User";
    constructor() {
        this.columns = [
            { Name: "FullName", Header: "Name", DataType: "string" },
            { Name: "PrimaryContactNo", Header: "Contact No", DataType: "string" },
            { Name: "PrimaryEmail", Header: "Email", DataType: "string" },
            { Name: "UserStatus", Header: "Type", DataType: "string" },
            { Name: "Gender", Header: "Gender", DataType: "string" },
            { Name: "Occupation", Header: "Occupation", DataType: "string" },
            { Name: "Role", Header: "Role", DataType: "string" }
        ];
        this.isLoad = true;
    }
    
}